import React, {memo} from 'react';
import {useComponent} from './hooks/useComponent';

import './SearchDestinationSummaryDetails.less';

const SearchDestinationSummaryDetails = memo(function SearchDestinationSummaryDetails() {
    const {
        className,
        id,
        label,
        rightContent,
        handleClick,
        handleKeyPress,
        handleFocus,
        dateString,
        guestString
    } = useComponent();

    return (
        <div className={className} id={id} label={label} onClick={handleClick} onFocus={handleFocus} onKeyPress={handleKeyPress} aria-hidden="true">
            <div className="summary-field__container form-control">
                <div className="summary-field__summary">
                    <div className="summary-field__destination">
                        {label}
                    </div>
                    <div className="summary-field__details">
                        <div className="summary-details__dates">{dateString}</div>
                        <span className="summary-details__bullet">{'.'}</span>
                        <div className="summary-details__guests">{guestString}</div>
                    </div>
                </div>
                <span className="search-form__icon search-form__icon--auto search-form__icon--edit">
                    {rightContent}
                </span>
            </div>
        </div>
    );
});

SearchDestinationSummaryDetails.whyDidYouRender = true;

export {SearchDestinationSummaryDetails};
